import { Button, Paper, Stack, Typography } from '@mui/material';
import { useDownloadProductImageQuery, useGetProductImageQuery, useUploadProductImageMutation } from '../features/products/skuImageSlice';
import Loading from './Loading';
import no_images from '../images/no_images@2x.png';
import DropArea from './DropArea';
import { capitalized } from '../helpers/strings';
import { useCallback, useState } from 'react';
import AlignmentEditor from './AlignmentEditor';
import { useGetSKUImagesQuery } from '../features/model/skuSlice';

const SKUImageView = ({skuimage=null, product, purpose, showUpload=false, maxWidth=300}) => {
    const skip_load = (skuimage===null);
    const {data: image, error, isLoading } = useDownloadProductImageQuery({skuimage_id: skuimage?.id | null}, {skip: skip_load})

    const [uploadProductImage] = useUploadProductImageMutation();
    const uploadImage = useCallback((files) => {
        let file = files[0];
        const reader = new FileReader()
        reader.onabort = () => console.log('file reading was aborted')
        reader.onerror = () => console.log('file reading has failed')
        reader.onload = () => {
          const binaryStr = reader.result
          uploadProductImage({sku_id: product.id, purpose: purpose, data: binaryStr})
        }
        reader.readAsArrayBuffer(file)
    });

    if (isLoading) {
        return <Loading />;
    }
    if (error) {
        return <div>Error: {error}</div>
    }

    let imgelement = [];

    if(showUpload) {
        imgelement.push(<DropArea key="upload" fileHandler={uploadImage}/>);
    }
    if(image) {
        imgelement.push(<img key="image" src={image} alt="Preview" style={{borderRadius: 4, maxWidth: maxWidth, height: "auto"}} />)
    }

    return <Stack key="skuimage" spacing={1}>
            {imgelement}
        </Stack>;
}

export { SKUImageView };